import * as React from 'react';
import { useFela } from 'react-fela';
import { createFlexChildCSSProps, createFontCSSProps, createMarginCSSProps, createPaddingCSSProps, createStylingCSSProps, } from './base';
import { createResponsiveStyles } from './utils';
function createTextCSSStyle(props, theme, outsideMediaQuery) {
    return {
        display: 'inline-block',
        ...createMarginCSSProps(props, theme),
        ...createPaddingCSSProps(props, theme),
        ...createFlexChildCSSProps(props, theme, outsideMediaQuery),
        ...createFontCSSProps(props, theme),
        ...createStylingCSSProps(props, theme),
    };
}
export function Text(props) {
    const { style, onClick, onMouseDown, onMouseOut, onMouseOver, onScroll, htmlAttrs, testId, innerRef, children, ...styleProps } = props;
    const { css, theme } = useFela();
    const styles = createResponsiveStyles(styleProps, createTextCSSStyle, theme);
    return React.createElement('span', {
        className: css([styles, style]),
        'data-testid': testId,
        onClick,
        onMouseDown,
        onMouseOut,
        onMouseOver,
        onScroll,
        ...htmlAttrs,
        ref: innerRef,
    }, children);
}
//# sourceMappingURL=Text.js.map